<template>
  <div class="c-l">
    <div class="c-l-t">
      <img class="c-l-t-a" :src="member.head_portrait? member.head_portrait: defultuserimg" alt/>
      <div class="c-l-t-s clearfix">
        <span>{{ member.name }}</span>
      </div>
      <div class="c-l-t-g clearfix" :class="`${member.level == 0 ? 'c-l-t-d' : ''} ${applayoverdue?'c-l-t-g-applay':'c-l-t-g-overdue'}`">
        <img
          v-if="member.level != 0&&!applayoverdue"
          class="c-l-t-i-m"
          src="../assets/np18.png"
          alt
        />
        <img
          v-if="member.level != 0&&applayoverdue"
          class="c-l-t-i-m"
          src="../assets/18.png"
          alt
        />
        <div v-if="member.level == 0&&!member.is_executive_vice_president" class>非会员单位</div>
        <div v-else-if="member.level == 1&&!member.is_executive_vice_president" class>团体会员单位</div>
        <div v-else-if="member.level == 2&&!member.is_executive_vice_president" class>理事单位</div>
        <div v-else-if="member.level == 3&&!member.is_executive_vice_president" class>常务理事单位</div>
        <div v-else-if="member.level == 4&&!member.is_executive_vice_president" class>副会长单位</div>
<!--        <div v-if="member.is_executive_vice_president">常务副会长单位</div>-->
      </div>
      <div v-if="member.level != 0">
        <div class="c-l-t-t">会员有效期至{{ member.end_at }}</div>
        <div style="background-color:#FF8640" class="c-l-t-b" @click="renew">续费</div>
        <div v-if="member.id" class="c-l-t-b" @click="dialogShowCertificate = true">查看电子证书</div>
      </div>

      <div
        v-if="member.level == 0"
        class="c-l-t-b"
        style="margin-top: 28px"
        @click="onApplyTap"
      >
        申请成为会员
      </div>
    </div>
    <div class="c-l-b">
      <div
        v-for="(item, index) in navItem"
        v-bind:key="index"
        :class="{ active: index == code }"
        class="c-l-b-item"
        @click="gopath(item.name, item.val, index)"
      >
        <span>{{ item.val }}</span>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="dialog" v-if="isrenew == true">
        <h3 class="renewtimeout">续费截止日期：</h3>
        <div class="renewtime">
          <p>{{ member.end_at }}</p>
        </div>
        <p class="content">
          尊敬的{{ state_text }}：
          <br />请联系贵州省燃气协会管理员进行会员续费，联系电话0851-85817948
        </p>
<!--        <div class="renewradio">-->
<!--          <div class="renewradio_title">选择支付方式：</div>-->
<!--          <div class="renewradio_content">-->
<!--            <el-radio-group-->
<!--              v-model="pay_type"-->
<!--              size="small"-->
<!--            >-->
<!--              <el-radio :label="1">对公支付</el-radio>-->
<!--              <el-radio :label="0">个人支付</el-radio>-->
<!--            </el-radio-group>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="btn" @click="gorenew">-->
<!--          <p>去续费</p>-->
<!--        </div>-->
      </div>
      <div class="dialog" v-if="isrenew == false">
        <img
          style="width: 153px; height: 140px"
          src="../assets/faile.png"
          alt
        />
        <p style="color: #333333; font-size: 20px">暂时不可续费</p>
        <p style="margin-top: 7px">请于本年限最后一个月内续费</p>
        <div class="knowbtn" @click="know">
          <p>知道了</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisiblepay"
      width="30%"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <p style="font-size: 16px; color: #333333">请扫下方二维码完成缴费</p>
        <div style="
            width: 100%;
            display: flex;
            justify-content: space-evenly;
          ">
          <div class="zhifu">
            <svg class="icon svg-icon" aria-hidden="true" v-html="ccb">
              <svg xmlns="http://www.w3.org/2000/svg" />
            </svg>
            <img
              style="width: 50px; height: 50px"
              src="../assets/ccb.jpeg"
              alt
            />
          </div>
          <use xlink:href="#icon-houcangguanlisvg"></use>
        </div>
        <el-button style="color: #194abe; width: 90%" @click="ispaye()">已确定扫码成功</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogShowCertificate"
      width="900px">
      <div class="" >
        <el-image
          style="width:800px;"
          :src="Certificate + member.id"
          ></el-image>
      </div>
      <div style="padding: 10px;">
        <el-button @click="printNewWindow(Certificate + member.id)" type="primary">打印</el-button>
       <el-button @click="downloadIamge(Certificate + member.id,'电子证书')" type="success">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { GetMember, GetBaseURL } from "../utils/api.js";
import { Base64 } from "js-base64";
import {
  myOrder,
  Apply,
  ApplyInfo,
  renewOrder, //支付
} from "../utils/api.js";
export default {
  name: "Members",

  data() {
    return {
      applayoverdue:false,//会员是否到期
      defultuserimg:require('../assets/6880@2x.png'),
      isrenew: null,
      state_text: "会员单位",
      code: 0,
      member: {},
      info: {},
      dialogVisible: false,
      dialogVisiblepay: false,
      Certificate: GetBaseURL +"GetUserCertificate/",
      dialogShowCertificate: false,
      navItem: [
        {
          val: "基础信息",
          name: "infor",
        },
          {
              val: "申请会员",
              name: "apply",
          },
        {
          val: "奖项管理",
          name: "award",
        },
        {
          val: "会员升级",
          name: "upgrade",
        },
        {
          val: "申报奖项",
          name: "declear",
        },
        {
          val: "申报记录",
          name: "Declar_record",
        },
        // {
        //   val: "缴费记录",
        //   name: "record",
        // },
        {
          val: "业绩申报",
          name: "performance",
        },
        {
          val: "消息通知",
          name: "news",
        },
          {
              val: "账号设置",
              name: "account",
          },
      ],
      wechat: "", //微信支付二维码
      alipay: "",
      ccb: "",
      ccb_corporate_url: "", // 对公链接

      order_id: '',
      pay_type: 1, // 1=对公
    };
  },
  watch: {
    $route(to) {
      console.log(to);
      this.cheght(to);
    },
    navItem(){
      if (this.code>1) {
        this.code-=1
      }

    }
  },
  created(){
    this.getmember();
  },
  async mounted() {
    // this.navItem = [
    //   {
    //     val: "奖项评审",
    //     name: "/Awardreview",
    //   },
    //   {
    //     val: "评审记录",
    //     name: "/Reviewrecords",
    //   },
    // ];
    this.cheght(this.$route);
    this.initData();
  },
  methods: {
    async getmember() {
      let info = await ApplyInfo();
      this.info = info;
      let member = await GetMember();
      switch (member.level) {
        case 1:
          this.state_text = "会员单位";
          break;
        case 2:
          this.state_text = "理事单位";
          break;
        case 3:
          this.state_text = "常务理事单位";
          break;
        case 4:
          this.state_text = "副会长单位";
          break;
      }
      let applaytime = new Date(member.end_at).getTime()
      let nowtime = new Date().getTime()
      if (nowtime-applaytime>=0) {
        this.applayoverdue = false
      }else{
        this.applayoverdue = true
      }
      this.$store.commit('isapplayoverdue',this.applayoverdue)
      member.end_at?member.end_at = member.end_at.slice(0,10):''
      this.member = member;
      if (member.level!=0) {
        this.navItem.splice(2,1)
      }
      this.$store.commit('isprize',member.level)
      this.$forceUpdate();
    },
    async initData() {
      let info = await ApplyInfo();
      this.info = info;
    },
    checkOrder(order_id) {
      let timer = null;
      let timeout = 0;
      timer = setInterval(() => {
        timeout++;
        myOrder(order_id).then((res) => {
          if (res.pay_status == 1) {
            this.ispaye();
            this.dialogVisiblepay = false;
            clearInterval(timer);
            this.getmember();
            this.initData();
          }
        });
        if (timeout >= 30) {
          this.ispaye();
          clearInterval(timer);
          this.dialogVisiblepay = false;
          this.getmember();
          this.initData();
        }
        if (this.dialogVisible == false && this.dialogVisiblepay == false) {
          clearInterval(timer);
        }
      }, 1000);
    },
    ispaye() {
      this.dialogVisiblepay = false;
      this.dialogVisible = false;
    },
    //打开支付弹框
    gorenew() {
      this.dialogVisible = false;
      if (this.pay_type == 1) {
        window.open(this.ccb_corporate_url, '_blank');
      } else {
        this.dialogVisiblepay = true;
      }
      this.checkOrder(this.order_id)
    },
    //知道了
    know() {
      this.dialogVisible = false;
      this.dialogVisiblepay = false;
    },
    //续费
    renew() {
      let that = this;
      this.dialogVisible = true;
      this.dialogVisiblepay = false;
      renewOrder().then(
        (res) => {
          this.isrenew = true;
          this.order_id = res.order_id;
          this.ccb = Base64.decode(res.ccb);
          this.ccb_corporate_url = res.ccb_corporate_url;
        },
        (err) => {
          this.isrenew = false;
          console.log(err);
        }
      );
    },
    gopath(name, title, index) {
        console.log(name,'gopath')
      this.code = parseInt(index);
      // let pathname='member/'+name;
      this.$router.push({
        path: name,
        query: {
          name: title,
        },
      });
    },
    cheght(item) {
      const fjjrjk = this.navItem.findIndex((val) => {
        console.log(999, item.path, val.name);
        return item.path.indexOf(val.name) != -1;
      });
      this.code = parseInt(fjjrjk);
    },
    onApplyTap() {
      this.$router.push({
        path: "apply",
      });
    },
    // 跳转修改资料
    onMemberTap() {
      this.$router.push({
        path: "infor",
      });
    },

  printNewWindow(imgSrc) {
  let oWin = window.open('', 'pringwindow', 'menubar=no,location=no,resizable=yes,scrollbars=no,status=no,width=1000,height=660')
  oWin.document.fn = function() {
      if (oWin) {
          oWin.print()
          oWin.close()
      }
  }
  let html = '<div style="height: 100%;width: 100%;">' + `<img src="${imgSrc}" onload="fn()" style="max-height:100%;max-width: 100%;" />` + '</div>'
  oWin.document.open()
  oWin.document.write(html)
  oWin.document.close()
  },

downloadIamge(imgsrc, name) {
  var image = new Image();
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      var context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      var url = canvas.toDataURL("image/png");

      var a = document.createElement("a");
      var event = new MouseEvent("click");
      a.download = name || "photo";
      a.href = url;
      a.dispatchEvent(event);
  };
  image.src = imgsrc;
},

  },
};
</script>
<style lang="less" scoped>
.dialog {
  max-width: 454px;
  padding: 0 46px;
  box-sizing: border-box;
  text-align: center;
  margin: 0 auto 20px;
}
.btn,
.knowbtn {
  cursor: pointer;
  margin: 0 auto;
  margin-top: 18px;
  max-width: 177px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #194abe;
  opacity: 1;
  border-radius: 4px;
  p {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 45px;
    color: #194abe;
  }
}
.knowbtn {
  border: 1px solid #7c828a;
  margin-top: 43px;
  p {
    color: #7c828a;
  }
}
.renewtimeout {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #333333;
}
.content {
  margin-top: 16px;
  text-align: start;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #7c828a;
}
.renewtime {
  margin: 0 auto;
  max-width: 224px;
  height: 45px;
  background: #fff7e8;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 45px;
    color: #e51725;
  }
}
.renewradio {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  height: 45px;
  background: #fff7e8;
  opacity: 1;
  border-radius: 4px;
  font-size: 14px;

  .renewradio_title {
    color: #409EFF;
    font-weight: bold;
  }
}
.c-l-t-i-m {
  width: 29px;
  height: 21px;
}

.c-l {
  float: left;

  &-t {
    display: flex;
    flex-direction: column;
    align-items: center;
      background-color: #3D63DF;
    background-repeat: no-repart;
    background-size: cover;
    padding-bottom: 20px;
    &-a {
      width: 222px;
      height: 117px;
      margin-top: 30px;
    }

    &-s {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 10px;
      width: 262px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: inline-block;
        max-width: 222px;
      }
    }

    &-g {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 16px;
      height: 24px;
      margin: 0 auto;
      margin-top: 10px;
      padding: 5px 10px;
    }
    &-g-applay{
      background: linear-gradient(270deg, #e51725 0%, #730c13 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
    }
    &-g-overdue{
      background: linear-gradient(90deg, #3D63DF 0%, #3D63DF 31%, #FF8640 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
    }

    &-d {
      background: #a4aab5 !important;
    }

    &-i {
      display: inline-block;
      float: left;
      cursor: pointer;
    }

    &-t {
      color: #ffffff;
      font-size: 14px;
      opacity: 0.6;
      margin-top: 10px;
    }

    &-b {
      // width: 76px;
      padding: 0px 10px;
      height: 38px;
      background: rgba(255, 255, 255, 0.18);
      opacity: 1;
      line-height: 38px;
      margin: 0 auto;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
        border-radius: 4px 4px 4px 4px;
        width:180px;
    }
  }

  &-b {
    width: 262px;
    height: auto;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding-top: 14px;
    padding-bottom: 28px;

    &-item {
      height: 47px;
      text-align: center;
      line-height: 47px;
      color: #7c828a;
      font-size: 18px;

      span {
        padding-bottom: 12px;
        border-bottom: 1px double #d4dbdd;
        cursor: pointer;
      }
    }
  }

  .active {
    background: url("../assets/linhe.png");
    background-repeat: no-repart;
    background-size: contain;
    color: #194abe;
    font-weight: bold;

    span {
      border: none;
    }
  }
}
</style>
